<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <table class="table table-condensed table-striped">
                <thead>
                <tr>
                    <th class="col-xs-2 text-center">
                        <input type="checkbox" @change="toggleSelected">
                    </th>

                    <th class="col-xs-8">
                        Name
                    </th>

                    <th class="col-xs-2"></th>

                    <th class="col-xs-4">
                        Portal
                    </th>

                    <th class="col-xs-2"></th>

                    <th class="col-xs-4">
                        Price
                        <small>(List Price)</small>
                    </th>

                    <th class="col-xs-2"></th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="ad in ads.data">
                    <td class="text-center">
                        <input
                                type="checkbox"
                                v-model="selected"
                                :value="ad"
                                :disabled="ad.is_locked && missingPermission('admin')"
                        >
                    </td>

                    <td>
                        <router-link :to="order.data.id + '/' + ad.type + '/' + ad.id">
                            {{ ad.name }}
                        </router-link>
                    </td>

                    <td>
                        <ad-detail-icons :ad="ad" class="pull-right"></ad-detail-icons>
                    </td>

                    <td>
                        <router-link :to="'/portals/' + ad.portal.id">
                            {{ ad.portal.name }}
                        </router-link>
                    </td>

                    <td>
                        <ad-cost-icons :ad="ad" class="pull-right"></ad-cost-icons>
                    </td>

                    <td>
                        {{ ad.price | price }}
                        <small>({{ ad.list_price | price }})</small>
                    </td>

                    <td class="text-right">
                        <div class="btn-group list-actions">
                            <router-link :to="order.data.id + '/' + ad.type + '/' + ad.id" class="btn btn-sm">
                                <i class="fa fa-search"></i>
                            </router-link>

                            <button type="button" class="btn btn-sm" @click="destroy(ad)"
                                    :disabled="ad.is_locked && !hasPermission('admin')">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </td>
                </tr>

                <tr v-if="!ads.data.length">
                    <td colspan="7" class="text-center">
                        <i>
                            There are no ads to display.
                        </i>
                    </td>
                </tr>
                </tbody>

                <tfoot v-if="ads.data.length">
                <tr>
                    <td colspan="4" class="text-right">
                        Subtotal
                    </td>

                    <td></td>

                    <td colspan="2">
                        {{ subTotalPrice | price }}
                        <small>({{ subTotalListPrice | price }})</small>
                    </td>
                </tr>

                <tr>
                    <td colspan="4" class="text-right">
                        Agency Commission
                    </td>

                    <td></td>

                    <td colspan="2">
                        {{ -totalAgencyCommission | price }}
                    </td>
                </tr>

                <tr>
                    <td colspan="4" class="text-right">
                        Third Party Costs
                    </td>

                    <td></td>

                    <td colspan="2">
                        {{ -totalThirdPartyCosts | price }}
                    </td>
                </tr>

                <tr>
                    <td colspan="4" class="text-right">
                        <b>
                            Total
                        </b>
                    </td>

                    <td></td>

                    <td colspan="2">
                        <b>
                            {{ totalPrice | price }}
                        </b>
                    </td>
                </tr>
                </tfoot>
            </table>

            <div class="btn-group dropup">
                <button type="button" class="btn btn-black btn-sm dropdown-toggle" data-toggle="dropdown"
                        :disabled="selected.length === 0">
                    <i class="fa fa-cogs"></i> List Functions <span class="caret"></span>
                </button>

                <ul class="dropdown-menu">
                    <li>
                        <a href="#" data-toggle="modal" data-target="#create-ad-discount-modal">
                            <i class="fa fa-dollar-sign"></i> Discount
                        </a>
                    </li>

                    <li>
                        <a href="#" data-toggle="modal" data-target="#create-agency-commission-modal">
                            <i class="fa fa-dollar-sign"></i> Agency Commission
                        </a>
                    </li>

                    <li>
                        <a href="#" data-toggle="modal" data-target="#create-third-party-costs-modal">
                            <i class="fa fa-dollar-sign"></i> Third Party Costs
                        </a>
                    </li>

                    <li>
                        <a href="#" @click.prevent="resetPriceForSelected">
                            <i class="fa fa-times"></i> Reset Price
                        </a>
                    </li>

                    <li>
                        <a href="#" @click.prevent="split">
                            <i class="fa fa-code-branch"></i> Split
                        </a>
                    </li>

                    <li role="separator" class="divider"></li>

                    <li>
                        <a @click.prevent="destroySelected">
                            <i class="fa fa-trash"></i> Delete
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <create-ad-discount :ads="selected" @created="listActionDone"></create-ad-discount>

        <create-agency-commission :ads="selected" @created="listActionDone"></create-agency-commission>

        <create-third-party-costs :ads="selected" @created="listActionDone"></create-third-party-costs>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import notify from '@/notify'
    import AdCostIcons from '@/components/Icons/AdCostIcons'
    import AdDetailIcons from '@/components/Icons/AdDetailIcons'
    import CreateAdDiscount from '@/pages/Companies/Companies/Edit/Modals/CreateAdDiscount'
    import CreateAgencyCommission from '@/pages/Companies/Companies/Edit/Modals/CreateAgencyCommission'
    import CreateThirdPartyCosts from '@/pages/Companies/Companies/Edit/Modals/CreateThirdPartyCosts'
    import Permissions from '@/mixins/Permissions'

    export default {
        components: {AdCostIcons, AdDetailIcons, CreateAdDiscount, CreateAgencyCommission, CreateThirdPartyCosts},

        mixins: [Permissions],

        model: {
            prop: 'ads',
        },

        props: ['order', 'ads'],

        data() {
            return {
                selected: []
            }
        },

        computed: {
            subTotalPrice() {
                return this.ads.data.reduce((total, ad) => {
                    return total + ad.price
                }, 0)
            },

            subTotalListPrice() {
                return this.ads.data.reduce((total, ad) => {
                    return total + ad.list_price
                }, 0)
            },

            totalAgencyCommission() {
                return this.ads.data.reduce((total, ad) => {
                    return total + ad.agency_commission
                }, 0)
            },

            totalThirdPartyCosts() {
                return this.ads.data.reduce((total, ad) => {
                    return total + ad.third_party_costs
                }, 0)
            },

            totalPrice() {
                return this.subTotalPrice - this.totalAgencyCommission - this.totalThirdPartyCosts
            }
        },

        methods: {
            toggleSelected(e) {
                if (e.target.checked) {
                    return this.selected = this.ads.data.filter(ad => !ad.is_locked || this.hasPermission('admin'))
                }

                this.selected = []
            },

            destroy(ad) {
                modal.confirm('Are you sure that you want to delete the ad?', () => {
                    this.getDestroyPromise(ad)
                        .then(() => {
                            notify.success('The ad was deleted')

                            this.listActionDone()
                        })
                })
            },

            destroySelected() {
                modal.confirm('Are you sure that you want to delete the ads?', () => {
                    Promise.all(this.selected.map(ad => this.getDestroyPromise(ad)))
                        .then(() => {
                            notify.success('The ads were deleted')

                            this.listActionDone()
                        })
                })
            },

            getDestroyPromise(ad) {
                return http.delete('/api/v2/' + ad.type + '/' + ad.id)
            },

            resetPriceForSelected() {
                modal.confirm('Are you sure that you want to reset the price for the selected ads?', () => {
                    http.post('/api/v1/ad-price-resets', {ads: this.selected})
                        .then(() => {
                            notify.success('The prices were reset')

                            this.listActionDone()
                        })
                        .catch(this.catchValidationErrors)
                })
            },

            listActionDone() {
                this.selected = []

                this.$emit('reload')
            },

            split() {
                modal.confirm('Are you sure that you want to split the selected ads to a new order?', () => {
                    http.post('/api/v1/split-orders', {order_id: this.order.data.id, ads: this.selected})
                        .then(response => {
                            notify.success('The ads were split')

                            this.$router.push('./' + response.data.data.id)
                        })
                        .catch(this.catchValidationErrors)
                })
            },

            getAgencyCommission(ad) {
                return 'Agency Commission: ' + this.$options.filters.price(ad.agency_commission)
            },

            getThirdPartyCosts(ad) {
                return 'Third Party Costs: ' + this.$options.filters.price(ad.third_party_costs)
            }
        }
    }
</script>
